import React from "react";
import { Provider } from "react-redux";
import { store } from "./configureStore";

export const ReduxProvider: React.FC<{}> = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};
